/** @jsxImportSource @emotion/react */
import React from 'react'

/**
 * @interface ChevronDownIconProps
 * @property {number} [width=16] - Width of the icon in pixels
 * @property {number} [height=16] - Height of the icon in pixels
 * @property {string} [fill='white'] - Fill color for the icon
 */
interface ChevronDownIconProps {
  width?: number
  height?: number
  fill?: string
}

/**
 * ChevronDown icon component - renders a downward pointing chevron
 *
 * A simple SVG icon component that displays a chevron pointing downward.
 * Commonly used in dropdowns, accordions, and other expandable UI elements.
 * The component is memoized to prevent unnecessary re-renders.
 *
 * @param props - Component props as defined in ChevronDownIconProps
 * @returns JSX element representing a chevron down icon
 */
const ChevronDownIcon: React.FC<ChevronDownIconProps> = React.memo(
  ({ width = 16, height = 16, fill = 'white' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M7.53334 9.53333L5.80001 7.8C5.5889 7.58889 5.54179 7.34733 5.65867 7.07533C5.77512 6.80289 5.98334 6.66666 6.28334 6.66666H9.71667C10.0167 6.66666 10.2249 6.80289 10.3413 7.07533C10.4582 7.34733 10.4111 7.58889 10.2 7.8L8.46667 9.53333C8.40001 9.6 8.32779 9.65 8.25001 9.68333C8.17223 9.71666 8.0889 9.73333 8.00001 9.73333C7.91112 9.73333 7.82779 9.71666 7.75001 9.68333C7.67223 9.65 7.60001 9.6 7.53334 9.53333Z'
        fill={fill}
      />
    </svg>
  )
)

export default ChevronDownIcon
